
























































































































import Vue from "vue";
import { Form } from "element-ui";
import { axios } from "@/plugins";

export default Vue.extend({
  name: "Invite",
  props: {
    tenantId: String
  },
  data() {
    return {
      dialog: false,
      isEdit: false,
      loading: false,
      ruleForm: {
        type: "NFS",
        name: "",
        description: "",
        path: "",
        server: "",

        monitors: "",
        adminId: "",
        adminSecretKey: "",
        pool: "",
        userId: "",
        userSecretKey: "",
        fsType: "ext4",
        imageFormat: "2",
        imageFeatures: "layering"
      },
      rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        type: [{ required: true, message: "请选择类型", trigger: "change" }],
        path: [{ required: true, message: "请输入路径", trigger: "blur" }],
        server: [{ required: true, message: "请输入地址", trigger: "blur" }],
        monitors: [{ required: true, trigger: "blur" }],
        adminId: [{ required: true, trigger: "blur" }],
        adminSecretKey: [{ required: true, trigger: "blur" }],
        pool: [{ required: true, trigger: "blur" }],
        userId: [{ required: true, trigger: "blur" }],
        userSecretKey: [{ required: true, trigger: "blur" }],
        fsType: [{ required: true, trigger: "blur" }],
        imageFormat: [{ required: true, trigger: "blur" }],
        imageFeatures: [{ required: true, trigger: "blur" }]
      }
    };
  },
  methods: {
    show() {
      this.dialog = true;
    },
    quit() {
      this.ruleForm = JSON.parse(
        JSON.stringify((this as any).$options.data().ruleForm)
      );
      (this.$refs.ruleForm as Form).clearValidate();
      this.dialog = false;
    },
    submit() {
      (this.$refs.ruleForm as any).validate((valid: any) => {
        if (valid) {
          this.loading = true;
          if (!this.isEdit) {
            this.create();
          }
        }
      });
    },
    create() {
      let data = null;
      if (this.ruleForm.type === "NFS") {
        data = {
          type: "NFS",
          nfs: {
            nfsServer: this.ruleForm.server,
            nfsPath: this.ruleForm.path,
            storageClassName: this.ruleForm.name,
            description: this.ruleForm.description
          }
        };
      } else if (this.ruleForm.type === "CEPH_RBD") {
        data = {
          type: "CEPH_RBD",
          ceph: {
            storageClassName: this.ruleForm.name,
            provisioner: "kubernetes.io/rbd",
            description: this.ruleForm.description,
            monitors: this.ruleForm.monitors,
            adminId: this.ruleForm.adminId,
            adminSecretKey: this.ruleForm.adminSecretKey,
            pool: this.ruleForm.pool,
            userId: this.ruleForm.userId,
            userSecretKey: this.ruleForm.userSecretKey,
            fsType: this.ruleForm.fsType,
            imageFormat: this.ruleForm.imageFormat,
            imageFeatures: this.ruleForm.imageFeatures
          }
        };
      }
      axios
        .post(`/storageclass/${this.tenantId}`, data)
        .then(() => {
          this.$message.success("存储卷创建成功");
          this.quit();
          this.$emit("afterEdit");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
});
